import { IconInstitute } from './icons/icon-institute';
import { IconLicense } from './icons/icon-license';
import { IconShield } from './icons/icon-shield';

export const MAIN_SECTIONS = [
  {
    icon: <IconLicense />,
    title: 'Globally licensed and trusted',
    body: 'Licensed across the U.S., UK, and EU to support regulated fundraising, trading, and financial services. Trusted operator across major jurisdictions.',
  },
  {
    icon: <IconInstitute />,
    title: 'Built for institutional-grade finance',
    body: 'Registered to offer end-to-end infrastructure of traditional and digital assets, including issuance, brokerage, secondary trading, and transfer agency—all in one tech stack. ',
  },
  {
    icon: <IconShield />,
    title: 'Secure funding and payments',
    body: 'Licensed to move and manage money at scale, including state money transmitter coverage and MSB status. Ideal for powering revenue-sharing and community finance.',
  },
];

export const LEARN_SECTIONS = [
  {
    title: 'SEC Registered Funding Portal',
    body: 'Qualified to conduct Regulation Crowdfunding offerings for non-accredited and accredited investors alike in the United States.',
  },
  {
    title: 'Node & Market Infrastructure',
    body: 'Qualified to conduct an institutional investors and qualified investors while engaging in broker-dealer services and exchange services.',
  },
  {
    title: 'State Money Transmitter Licenses*',
    body: 'Qualified to conduct the comprehensive services for obtaining a Money Transmitter License in 48 U.S. states and D.C.',
    note: "Montana and New York state isn't included",
  },
  {
    title: 'SEC Registered Broker-Dealer',
    body: 'Qualified to conduct Regulation A+, Regulation D, and Regulation S offerings for accredited investors.',
  },
  {
    title: 'European Licenses',
    body: 'Qualifications to run similar operations overseas in the UK and EU. Expands our global reach.',
  },
  {
    title: 'FINRA Registered MSB',
    body: 'Conducting operations as a Money Services Business on a regular basis.',
  },
  {
    title: 'SEC Registered Transfer Agent*',
    body: 'Qualified to manages and records the transfer of traditional and digital securities.',
  },
  {
    title: 'SEC Registered ATS*',
    body: 'Qualified trading venue matching buy and sell orders for traditional and digital security.',
  },
  {
    title: 'SEC Registered Investment Advisor Firm',
    body: 'Qualified to act as an advisor and management firm on behalf of individual and institutional investors.',
  },
];
